import React from 'react';
import { CustomTypography } from 'shared/elements/CustomTypography';
import { LocationAndDateAttributes } from 'shared/interfaces/ICastingRole';
import { useStyles } from '../../Role.styles';

type Props = {
  type: string;
  data: LocationAndDateAttributes | null;
};

const LocationAndDateItem: React.FC<Props> = ({ type, data }) => {
  const classes = useStyles();

  return (
    <div className={classes.flexMiniColumnContainer}>
      <CustomTypography fontSize={18}>{type} Location and Date</CustomTypography>
      <CustomTypography fontSize={13}>{data && data.location ? data?.location : '–'}</CustomTypography>
      {data && data?.show_to?.length > 0 ? (
        <div className={classes.miniRow}>
          <CustomTypography fontSize={12} fontWeight={600}>
            Shared with:
          </CustomTypography>
          <CustomTypography fontSize={12}>
            {data && data?.show_to?.length > 0
              ? data?.show_to?.map((i, _) => (
                  <React.Fragment>{data?.show_to?.length === _ + 1 ? i : `${i}, `}</React.Fragment>
                ))
              : '–'}
          </CustomTypography>
        </div>
      ) : (
        <></>
      )}
      <div className={classes.miniRow}>
        {data && data?.dates?.length > 0 ? (
          data?.dates?.map((i, _) => (
            <div className={classes.locationAndDateItemContainer}>
              <CustomTypography fontSize={13}>{i}</CustomTypography>
            </div>
          ))
        ) : (
          <React.Fragment />
        )}
      </div>
      {data && data?.note && (
        <>
          <CustomTypography fontSize={13} color="success">
            Notes:
          </CustomTypography>
          <CustomTypography fontSize={15} fontWeight={600} style={{ wordBreak: 'break-word' }}>
            {data && data?.note}
          </CustomTypography>
        </>
      )}
    </div>
  );
};

export default LocationAndDateItem;
